import * as CryptoJS from "CryptoJS_MD5";
import * as _ from "underscore";

const tweets = [
  "This is a great site to help you read and boost your vocab",
  "For intermediate language learners - texts, videos, flashcards, etc.",
  "Generates flashcards while you read - really cool",
  "Amazing app for language learners who enjoy reading.",
  "Inline translations make reading other languages so much easier",
];

// stick with the same tweet for each user
let tweet;

export const fetch = (userID) => {
  if (tweet) {
    return tweet;
  }
  if (userID === "local") {
    tweet = tweets[_.random(tweets.length)];
  } else {
    tweet = tweets[Math.abs(CryptoJS.MD5(userID).words[0]) % tweets.length];
  }
  return tweet;
};
